import React from 'react'

import { TextField } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import { Card } from 'components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import constants from 'constants/index'
import helpers from 'helpers'

const ObservationSection = () => {
  const { control } = useFormContext()
  const { isShow, isPreAvaliation, fromCreate } =
    useThirdPartyManagementStepper()

  const { STEPS } = constants.tours.thirdPartyManagements

  return (
    <Card
      title="Observações"
      id={helpers.thirdPartyManegementPartners.getRisksTourStepId({
        STEPS,
        isPreAvaliation,
        fromCreate,
        step: 3,
      })}
    >
      <Controller
        as={
          <TextField
            fullWidth
            multiline
            minRows={5}
            variant="outlined"
            placeholder="Registre informações extras que desejar sobre este fornecedor. Estas observações não são compartilhadas com o fornecedor."
            disabled={isShow}
          />
        }
        control={control}
        name="observation"
      />
    </Card>
  )
}

export default ObservationSection
